export const ElementOrPointPropertyConverter = {
    convert: (attr) => {
        let el = document.querySelector(attr);
        return el ?? JSON.parse(attr);
    }
};
//}
